<div class="mtx-clock-wrapper">
  <div class="mtx-clock-center"></div>
  <div class="mtx-clock-hand" [ngStyle]="_hand"></div>
  <div class="mtx-clock-hours" [class.active]="_hourView">
    <div *ngFor="let item of _hours"
         class="mtx-clock-cell"
         [class.mtx-clock-cell-disabled]="!item.enabled"
         [class.mtx-clock-cell-selected]="_selectedHour === item.value"
         [style.fontSize]="item.fontSize"
         [style.left]="item.left+'%'"
         [style.top]="item.top+'%'">{{ item.displayValue }}</div>
  </div>
  <div class="mtx-clock-minutes" [class.active]="!_hourView">
    <div *ngFor="let item of _minutes"
         class="mtx-clock-cell"
         [class.mtx-clock-cell-disabled]="!item.enabled"
         [class.mtx-clock-cell-selected]="_selectedMinute === item.value"
         [style.left]="item.left+'%'"
         [style.top]="item.top+'%'">{{ item.displayValue }}</div>
  </div>
</div>
